import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { Group, Heading, OverlayTriggerStateContext } from "react-aria-components";
import { CloseX } from "./CloseX.js";
import { Divider } from "./Divider.js";
import { FeaturedIcon } from "./FeaturedIcon.js";
import { base, content, supportingText as supportingTextClass, text, title as titleClass, xButton } from "./ModalHeader.css.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CloseButton = t0 => {
  const $ = _c(6);
  const {
    onClose,
    closeButton
  } = t0;
  const state = React.useContext(OverlayTriggerStateContext);
  let t1;
  if ($[0] !== onClose || $[1] !== state) {
    t1 = () => {
      if (onClose) {
        onClose();
      } else {
        if (state) {
          state.close();
        }
      }
    };
    $[0] = onClose;
    $[1] = state;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = closeButton === true ? "rounded" : closeButton;
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = /*#__PURE__*/_jsx("div", {
      className: xButton,
      children: /*#__PURE__*/_jsx(CloseX, {
        onPress: t1,
        variant: "gray",
        size: "l",
        type: t2
      })
    });
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
const BaseModalHeader = (t0, ref) => {
  const $ = _c(42);
  let divider;
  let featuredIcon;
  let onClose;
  let paddingBottom;
  let props;
  let supportingText;
  let t1;
  let t2;
  let title;
  if ($[0] !== t0) {
    ({
      type: t1,
      closeButton: t2,
      title,
      supportingText,
      featuredIcon,
      onClose,
      paddingBottom,
      divider,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = divider;
    $[2] = featuredIcon;
    $[3] = onClose;
    $[4] = paddingBottom;
    $[5] = props;
    $[6] = supportingText;
    $[7] = t1;
    $[8] = t2;
    $[9] = title;
  } else {
    divider = $[1];
    featuredIcon = $[2];
    onClose = $[3];
    paddingBottom = $[4];
    props = $[5];
    supportingText = $[6];
    t1 = $[7];
    t2 = $[8];
    title = $[9];
  }
  const type = t1 === undefined ? "leftAligned" : t1;
  const closeButton = t2 === undefined ? true : t2;
  let t3;
  if ($[10] !== paddingBottom) {
    t3 = base({
      paddingBottom
    });
    $[10] = paddingBottom;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== type) {
    t4 = content({
      type
    });
    $[12] = type;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== featuredIcon) {
    t5 = featuredIcon && /*#__PURE__*/_jsx(FeaturedIcon, {
      ...featuredIcon,
      size: "l"
    });
    $[14] = featuredIcon;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== type) {
    t6 = text({
      type
    });
    $[16] = type;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== title) {
    t7 = /*#__PURE__*/_jsx(Heading, {
      slot: "title",
      className: titleClass,
      children: title
    });
    $[18] = title;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== supportingText) {
    t8 = supportingText != null && supportingText.trim().length > 0 && /*#__PURE__*/_jsx("div", {
      className: supportingTextClass,
      children: supportingText
    });
    $[20] = supportingText;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t6 || $[23] !== t7 || $[24] !== t8) {
    t9 = /*#__PURE__*/_jsxs(Group, {
      className: t6,
      children: [t7, t8]
    });
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t4 || $[27] !== t5 || $[28] !== t9) {
    t10 = /*#__PURE__*/_jsxs("div", {
      className: t4,
      children: [t5, t9]
    });
    $[26] = t4;
    $[27] = t5;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== closeButton || $[31] !== onClose) {
    t11 = closeButton !== false && /*#__PURE__*/_jsx(CloseButton, {
      onClose: onClose,
      closeButton: closeButton
    });
    $[30] = closeButton;
    $[31] = onClose;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== divider) {
    t12 = divider === true && /*#__PURE__*/_jsx(Divider, {});
    $[33] = divider;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== props || $[36] !== ref || $[37] !== t10 || $[38] !== t11 || $[39] !== t12 || $[40] !== t3) {
    t13 = /*#__PURE__*/_jsxs(Group, {
      ref: ref,
      ...props,
      className: t3,
      children: [t10, t11, t12]
    });
    $[35] = props;
    $[36] = ref;
    $[37] = t10;
    $[38] = t11;
    $[39] = t12;
    $[40] = t3;
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  return t13;
};
export const ModalHeader = /*#__PURE__*/React.forwardRef(BaseModalHeader);
//# sourceMappingURL=ModalHeader.js.map